export default __webpack_public_path__ + "static/media/switch_off.4cefe634.svg";